import { render, staticRenderFns } from "./DeviationPanel.vue?vue&type=template&id=5722e127&scoped=true&"
import script from "./DeviationPanel.vue?vue&type=script&lang=js&"
export * from "./DeviationPanel.vue?vue&type=script&lang=js&"
import style0 from "./DeviationPanel.vue?vue&type=style&index=0&id=5722e127&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5722e127",
  null
  
)

export default component.exports